import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { UserRole } from "@/lib/types";

interface AuthState {
  base: string;
  token: string | null;
  expiresAt: number | null;
  role: UserRole | null;
  username: string | null;
  setBase: (b: string) => void;
  setToken: (token: string, expiresIn: number, role: UserRole, username: string) => void;
  logout: () => void;
}

const DEFAULT_BASE =
  typeof window !== "undefined" && window.location.port === "5173"
    ? "" // dev: use vite proxy (same-origin)
    : ""; // prod: served from FastAPI (same-origin)

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      base: DEFAULT_BASE,
      token: null,
      expiresAt: null,
      role: null,
      username: null,
      setBase: (base) => set({ base }),
      setToken: (token, expiresIn, role, username) =>
        set({ token, expiresAt: Date.now() + expiresIn * 1000, role, username }),
      logout: () => set({ token: null, expiresAt: null, role: null, username: null }),
    }),
    {
      name: "tmc-auth",
      partialize: (s) => ({
        base: s.base,
        token: s.token,
        expiresAt: s.expiresAt,
        role: s.role,
        username: s.username,
      }),
    }
  )
);

export function isLoggedIn(): boolean {
  const { token, expiresAt } = useAuth.getState();
  if (!token) return false;
  if (expiresAt && expiresAt < Date.now()) return false;
  return true;
}
